export default function getViewport() {

  return {
    x: window.pageYOffset,
    y: window.pageXOffset,
    width: window.innerWidth,
    height: window.innerHeight
  }
}
